module.exports = __webpack_public_path__ + "static/media/bloomberg.f1f1f0fd.png";